import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins/ant-design-vue.js";
import "element-ui/lib/theme-chalk/index.css";

import { Cascader } from "element-ui";
Vue.use(Cascader);

Vue.config.productionTip = false;

let this_vue = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

export default this_vue;
